import React from 'react'
import ReactDOM from 'react-dom';
import AccordionItem from './subcomponent/AccordionItem';

export default function Accordion({content, layout}) {
  const data = JSON.parse(content);

  // check if data[0].data is an array will nullcheck
  const mode = data && data[0] && data[0].data && Array.isArray(data[0].data) ? 'nested' : 'flat';

  // Make it an array of index numbers
  if(!data) return null;
  const numberOfColumns = layout === 'two' ? 2 : 1;

  const uniqueKeyPrefix = "key_" + Math.random().toString(36).substring(7);


  if(numberOfColumns === 1) {
    return (
      <div className="grid grid-cols-1 gap-4">
        {data.map((item, index) => {

          return <AccordionItem item={item} index={index} mode={mode} key={uniqueKeyPrefix + index} />;
        } )}
      </div>
    )
  } 

  return (
    <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
      <div>
        {data.map((item, index) => {
          if (index % numberOfColumns === 0) {
            return <AccordionItem item={item} index={index} mode={mode} key={uniqueKeyPrefix + "_left_" + index} />;
          } 
        })}
      </div>
      <div>
        {data.map((item, index) => {
          if (index % numberOfColumns === 1) {
            return <AccordionItem item={item} index={index} mode={mode} key={index + "_right_" + index} />;
          }
        })}
      </div>
    </div>
  );
  
}

